<template>
  <div class="update-modal-mask">
    <div class="update-modal-dialog">
      <!-- <div class="version-tag">v2.7.0</div> -->
      <img
        @click="refresh"
        class="button"
        src="@/assets/images/update-system-button.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleAfterLeave() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    refresh() {
      this.handleAfterLeave();
      // window.location.replace(window.location.href); //没有刷新缓存
      location.reload(true); // 刷新了缓存
    },
  },
};
</script>

<style lang="less" scoped>
.update-modal-mask {
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;

  .update-modal-dialog {
    width: 474px;
    height: 504px;
    border-radius: 8px 8px 8px 8px;
    z-index: 100000;
    background: url(../assets/images/update-system-bg.png) no-repeat;
    background-size: contain;
    display: flex;
    justify-content: center;
    position: relative;

    .version-tag {
      left: 180px;
      top: 265px;
      position: absolute;
      padding: 0 12px;
      line-height: 24px;
      border-radius: 12px;
      color: #fff;
      font-weight: bold;
      font-size: 14px;
      background-color: #F87E0A;
    }
    .button {
      width: 264px;
      height: 42px;
      position: absolute;
      bottom: 36px;
      left: 50%;
      transform: translateX(-50%);
      cursor: pointer;
    }
  }
}
</style>
